export enum FailureReasonUsage {
    All = 'none',
    OriginalUnderwriting = 'underwriting-original',
    ResidualUnderwriting = 'underwriting-residual',
    UnderwritingReview = 'underwriting-review',
    NACHAResponse = 'nacha-response',
    PendingReason = 'pending-reason',
}

export const FailureReasonUsageLabel = new Map<string, string>([
    [FailureReasonUsage.All, 'All'],
    [FailureReasonUsage.OriginalUnderwriting, 'Original underwriting'],
    [FailureReasonUsage.ResidualUnderwriting, 'Residual underwriting'],
    [FailureReasonUsage.UnderwritingReview, 'Underwriting review'],
    [FailureReasonUsage.NACHAResponse, 'NACHA response'],
    [FailureReasonUsage.PendingReason, 'Pending reason']
]);

export interface FailureReasonBaseData {
    code?: string;
    externalCode?: string;
    name?: string;
    usage?: FailureReasonUsage[];
    allowToSpecifyCompetitors?: boolean;
}